import React, { useState, useEffect } from "react";
import { Container, Row, Col, FormGroup, Label, Input, FormText, Table } from "reactstrap";
// import { useNavigate } from "react-router-dom";
import { FormikSelect } from "../share/FormikSelect";
import { Formik, Field, Form, FieldArray } from "formik";
import * as Yup from "yup";
import "../share/form.css";
import Swal from 'sweetalert2'
import { DatePickerInput } from "../share/DatePickerInput";
import { BiShow } from "react-icons/bi";
import { BiHide } from "react-icons/bi";
import { GetVMdDept, GetProvince, GetIndustrial, GetTitleName } from "../share/api/MasterDataApi";
import { CustomInputNumeric } from '../share/CustomInputNumeric'
import { NumericFormat } from 'react-number-format';
import { Loading } from "../share/loading";
import { AddEditAuthorizedModal } from "./AddEditAuthorizedModal";
import { BsPlusLg } from "react-icons/bs";
import { AiOutlineDelete } from "react-icons/ai";
import { FiEdit3 } from "react-icons/fi";


export function RegisterComponent() {
    let rootColorErrors = "#d33";
    let rootColorPrimary = "#0A66C2";
    const registerationTypeNumber = 1;
    const registerType = "นิติบุคคล";
    // const navigate = useNavigate();
    const [isRevealPwd, setIsRevealPwd] = useState(false);
    const [isRevealPwd2, setIsRevealPwd2] = useState(false);
    const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[a-zA-Z\d]{8,}$/;
    const [loading, setLoading] = useState(false)
    // state ดึงข้อมูลจาก master data
    const [deptsData, setDeptsData] = useState([]);
    const [titleName, setTitleName] = useState([]);
    // console.log("titleName", titleName);
    const [locationProvince, setLocationProvince] = useState([]);
    const [locationAmphur, setLocationAmphur] = useState([]);
    const [locationTumbon, setLocationTumbon] = useState([]);
    const [industrialData, setIndustrialData] = useState([]);
    const [industryData, setIndustryData] = useState([]);
    const [searchCertificateNo, setSearchCertificateNo] = useState("");
    const [dataCertificate, setDataCertificate] = useState(null);
    // console.log("dataCertificate", dataCertificate);

    // state ของประเภทที่สมัคร ว่า user เป็น type ไหน แล้วก็จะโชว์ component แต่ละ type ให้
    const [checkedEntrepreneur, setCheckedentrepreneur] = useState(false);
    const [checkedTrainer, setCheckedTrainer] = useState(false);
    const [checkedSkillTesting, setCheckedSkillTesting] = useState(false);
    const [checkedGroupOfEntrepreneur, setCheckedGroupOfEntrepreneur] = useState(false);
    const [checkedEstimate, setCheckedEstimate] = useState(false);

    // state เก็บ register_type 
    const [regisType, setRegisType] = useState([]);
    // console.log(regisType);

    // state เพื่อที่จะ toggle label dept เฉยๆ 
    const [initialDept, setInitialDept] = useState("หน่วยงานกรมพัฒนาฝีมือแรงงานที่ต้องการติดต่อ");
    const [showName, setShowName] = useState(null);



    // state data เอาไว้หาค่าเลือกประเภทการสมัครเป็นอะไรบ้าง และเอาไว้เปลี่ยนป้ายหน่วยงานกรมพัฒฯ
    const [checkedDept, setCheckedDept] = useState([
        {
            id: "1",
            name: "ผู้ประกอบกิจการ",
            check: false,
            dept: "หน่วยงานกรมพัฒนาฝีมือแรงงานในพื้นที่ที่สำนักงานใหญ่ของสถานประกอบกิจการตั้งอยู่"

        },
        {
            id: "2",
            name: "ผู้ดำเนินการฝึก",
            check: false,
            dept: "หน่วยงานกรมพัฒนาฝีมือแรงงานในพื้นที่ที่ศูนย์ฝึกอบรมฝีมือแรงงานตั้งอยู่",

        },
        {
            id: "3",
            name: "ผู้ดำเนินการทดสอบมาตรฐานฝีมือแรงงาน",
            check: false,
            dept: "หน่วยงานกรมพัฒนาฝีมือแรงงานในพื้นที่ที่ศูนย์ฝึกอบรมฝีมือแรงงานตั้งอยู่",
        },
        // {
        //     id: "4",
        //     name: "กลุ่มผู้ประกอบกิจการ",
        //     check: false,
        //     dept: "หน่วยงานกรมพัฒนาฝีมือแรงงานในพื้นที่ที่ต้องการติดต่อ",
        // },
        {
            id: "5",
            name: "ศูนย์ประเมินความรู้ความสามารถ",
            check: false,
            dept: "หน่วยงานกรมพัฒนาฝีมือแรงงานในพื้นทีที่ศูนย์ประเมินฯ ตั้งอยู่",
        },
    ]);

    useEffect(() => {
        // setLoading(true)
        GetVMdDept({ setDeptsData, setLoading }) //ดึงmaster data หน่วยงานกรมพัฒฯ
        GetProvince({ setLocationProvince, setLoading }) // ดึง master data จังหวัด
        GetIndustrial({ setIndustrialData, setLoading }) // ดึงmaster data ประเภทอุตสาหกรรม 2 หลัก
        GetTitleName({ setTitleName, setLoading }) //ดึงคำนำหน้าชื่อ

    }, []);

    // เก็บค่าจากแบบฟอร์มและ state เอาไว้ทำ function onSubmit
    const initialValues = {
        checkedEntrepreneur: checkedEntrepreneur,
        checkedTrainer: checkedTrainer,
        checkedSkillTesting: checkedSkillTesting,
        checkedGroupOfEntrepreneur: checkedGroupOfEntrepreneur,
        checkedEstimate: checkedEstimate,
        type: registerationTypeNumber,
        customerTypeAr: regisType,
        dept: "", //หน่วยงานกรมพัฒนฯ
        entrepreneurName: "", //ชื่อบริษัท ผู้ประกอบกิจการ
        registerNumber: "", //เลขทะเบียนนิติบุคคล 13 หลัก
        ssoNumber: "", //เลขประกันสังคม 10 หลัก
        trainerName: "", //ชื่อผู้ดำเนินการฝึก
        groupOfEntrepreneurName: "", //ชื่อกลุ่มผู้ประกอบกิจการ
        addNo: "", //เลขที่
        addMoo: "", //หมู่
        addSoi: "",//ซอย
        addStreet: "", //ถนน
        addProvince: "", //จังหวัด
        addDistrict: "", // อำเภอ
        locationId: "",
        addTumbon: "", //ตำบล
        postcode: "", //รหัสไปรษณีย์
        tel: "", //เบอร์โทร
        fax: "", //โทรสาร
        email: "",
        contactName: "",
        contactNo: "",
        subIndustry: "", //ประเภทอุตสาหกรรม 2 หลัก
        activityType: "", //ประเภทกิจกรรม 5 หลัก
        typeBusiness: "", //ประกอบกิจการประเภท
        employDate: "", //วันที่มีจำนวนลูกจ้างมากกว่า 100 คน
        testLicenseNo: "",
        estimateLicenseNo: "",
        password: "",
        cpassword: "",
        fVat20: "",
        fMap: "",
        fIndustryLic: "",
        fLicense: "",
        // fAuthorize: "",
        fOther: "",
        term: "N",

        //เพิ่ม MA
        authorizedList: [],

    }

    const initialEmptyPerson = {
        //ที่อยู่
        authTitleId: "",
        authFullName: "",
        authPersonalId: "",
        authAddressNo: "",
        authAddressMoo: "",
        authAddressSoi: "",
        authAddressStreet: "",
        authAddressProvince: "",
        authAddressDistrict: "",
        authAddressTumbon: "",
        authAddressPostCode: "",
        authAddressLocationId: "",
        //ที่อยู่ปัจจุบัน
        currentAddressNo: "",
        currentAddressMoo: "",
        currentAddressSoi: "",
        currentAddressStreet: "",
        currentAddressProvince: "",
        currentAddressDistrict: "",
        currentAddressTumbon: "",
        currentAddressPostCode: "",
        currentAddressLocationId: "",
    };

    const [modalOpen, setModalOpen] = useState(false);
    const [editIndex, setEditIndex] = useState(null);
    const [editMode, setEditMode] = useState("add");
    const [editData, setEditData] = useState(initialEmptyPerson);

    async function checkedSkillTestingPreSubmit() {
        if (checkedSkillTesting) {
            if (dataCertificate === null) {
                return false
            } else {
                return true
            }
        } else {
            return true
        }
    }
    // submit แบบฟอร์ม
    const onSubmit = async (values) => {
        let pass = await checkedSkillTestingPreSubmit()
        if (pass) {
            let postData = new FormData();

            Object.entries(values).forEach(([key, value]) => {
                if (key === "authorizedList") {
                    postData.append(key, JSON.stringify(value));
                } else {
                    postData.append(key, value);
                }
            });
            try {
                let res = await fetch("/api/Registeration/saveRegisData", {
                    method: "POST",
                    body: postData
                });

                let resJson = await res.json();

                if (resJson.status === 1) {
                    Swal.fire({
                        icon: "success",
                        title: "ลงทะเบียนสำเร็จ",
                        text: "โปรดรอเจ้าหน้าที่ตรวจสอบและยืนยันผ่านทางอีเมล",
                        confirmButtonColor: "#0A66C2",
                        confirmButtonText: "ตกลง",
                    }).then((result) => {
                        if (result.isConfirmed) {

                            window.location.reload()
                        }
                    });
                } else {
                    Swal.fire({
                        icon: "error",
                        title: "ลงทะเบียนไม่สำเร็จ",
                        text: `เนื่องจาก ${resJson.message}`,
                        confirmButtonColor: "#0A66C2",
                        confirmButtonText: "ตกลง",
                    });
                }
            } catch (e) {
                // console.log(e)
            }
        } else {
            Swal.fire({
                icon: "info",
                title: "",
                text: "ไม่พบข้อมูลเลขที่ใบอนุญาตการเป็นผู้ดำเนินการทดสอบฯ",
                confirmButtonColor: "#0A66C2",
                confirmButtonText: "ตกลง",
            })
        }

    }

    const validateSchema = Yup.object().shape({
        checkedEntrepreneur: Yup.boolean(),
        checkedTrainer: Yup.boolean(),
        checkedSkillTesting: Yup.boolean(),
        checkedGroupOfEntrepreneur: Yup.boolean(),
        checkedEstimate: Yup.boolean(),
        customerTypeAr: Yup.array().of(
            Yup.string()
        ).min(1, "กรุณาเลือกประเภทการสมัครอย่างน้อย 1 รายการ"),
        dept: Yup.string().required("กรุณาเลือกหน่วยงาน"),
        addNo: Yup.string().required("กรุณากรอกเลขที่"),
        addProvince: Yup.string().required("กรุณาเลือกจังหวัด"),
        addDistrict: Yup.string().required("กรุณาเลือกอำเภอ/เขต"),
        addTumbon: Yup.string().required("กรุณาเลือกตำบล/แขวง"),
        postcode: Yup.string()
            .matches(/^[0-9]{5}$/, "รหัสไปรษณีย์ต้องประกอบไปด้วยตัวเลข 5 หลัก")
            .required("กรุณาระบุรหัสไปรษณีย์"),
        tel: Yup.string().required("กรุณากรอกเบอร์โทรศัพท์"),

        fax: Yup.string(),

        email: Yup.string()
            .email("รูปแบบอีเมลไม่ถูกต้อง")
            .required("กรุณากรอกอีเมล"),
        contactName: Yup.string().required("กรุณากรอกชื่อ-นามสกุลผู้ประสานงาน"),
        contactNo: Yup.string().required("กรุณากรอกเบอร์โทรผู้ประสานงาน"),

        fLicense: Yup.mixed().required("กรุณาแนบไฟล์สำเนาหนังสือรับรองการจดทะเบียนนิติบุคคลพร้อมวัตถุประสงค์"),
        entrepreneurName: Yup.string().when("checkedEntrepreneur", {
            is: true,
            then: Yup.string().required("กรุณากรอกชื่อผู้ประกอบกิจการ")
        }),
        ssoNumber: Yup.string().when("checkedEntrepreneur", {
            is: true,
            then: Yup.string().min(10, "เลขที่บัญชีนายจ้างต้องมีจำนวน 10 หลัก").required("กรุณากรอกเลขที่บัญชีนายจ้าง (10หลัก)"),
        }),
        subIndustry: Yup.string().when("checkedEntrepreneur", {
            is: true,
            then: Yup.string().required("กรุณาเลือกประเภทอุตสาหกรรม (หมวดย่อย 2 หลัก)"),
        }),
        activityType: Yup.string().when("checkedEntrepreneur", {
            is: true,
            then: Yup.string().required("กรุณาเลือกประเภทอุตสาหกรรม (กิจกรรม 5 หลัก)"),
        }),
        typeBusiness: Yup.string().when("checkedEntrepreneur", {
            is: true,
            then: Yup.string().required("กรุณากรอกประกอบกิจการประเภท"),
        }),
        // fMap: Yup.mixed(),
        fMap: Yup.mixed().when("checkedEntrepreneur", {
            is: true,
            then: Yup.mixed().required("กรุณาแนบไฟล์แผนที่ตั้งสถานประกอบกิจการ"),
        }),
        registerNumber: Yup.string()
            .when("checkedEntrepreneur", {
                is: true,
                then: Yup.string()
                    .min(13, "เลขทะเบียนนิติบุคคล/เลขทะเบียนพาณิชย์ ต้องมีจำนวน 13 หลัก")
                    .required(
                        "กรุณากรอกเลขทะเบียนนิติบุคคล/เลขทะเบียนพาณิชย์ (13หลัก)"
                    ),
            }).when("checkedTrainer", {
                is: true,
                then: Yup.string()
                    .min(13, "เลขทะเบียนนิติบุคคล/เลขทะเบียนพาณิชย์ ต้องมีจำนวน 13 หลัก")
                    .required(
                        "กรุณากรอกเลขทะเบียนนิติบุคคล/เลขทะเบียนพาณิชย์ (13หลัก)"
                    ),
            }).when("checkedSkillTesting", {
                is: true,
                then: Yup.string()
                    .min(13, "เลขทะเบียนนิติบุคคล/เลขทะเบียนพาณิชย์ ต้องมีจำนวน 13 หลัก")
                    .required(
                        "กรุณากรอกเลขทะเบียนนิติบุคคล/เลขทะเบียนพาณิชย์ (13หลัก)"
                    ),
            }).when("checkedGroupOfEntrepreneur", {
                is: true,
                then: Yup.string()
                    .min(13, "เลขทะเบียนนิติบุคคล/เลขทะเบียนพาณิชย์ ต้องมีจำนวน 13 หลัก")
                    .required(
                        "กรุณากรอกเลขทะเบียนนิติบุคคล/เลขทะเบียนพาณิชย์ (13หลัก)"
                    ),
            }).when("checkedEstimate", {
                is: true,
                then: Yup.string()
                    .min(13, "เลขทะเบียนนิติบุคคล/เลขทะเบียนพาณิชย์ ต้องมีจำนวน 13 หลัก")
            }),
        trainerName: Yup.string().when("checkedTrainer", {
            is: true,
            then: Yup.string().required("กรุณากรอกชื่อผู้ดำเนินการฝึก")
        }),

        testLicenseNo: Yup.string().when("checkedSkillTesting", {
            is: true,
            then: Yup.string().required("กรุณากรอกเลขที่ใบอนุญาตการเป็นผู้ดำเนินการทดสอบมาตรฐานฝีมือแรงงาน")
        }),
        licenseTestName: Yup.string().when("checkedSkillTesting", {
            is: true,
            then: Yup.string().required("กรุณากรอกชื่อผู้ดำเนินการทดสอบมาตรฐานฝีมือแรงงาน")
        }),

        groupOfEntrepreneurName: Yup.string().when("checkedGroupOfEntrepreneur", {
            is: true,
            then: Yup.string().required("กรุณากรอกชื่อกลุ่มผู้ประกอบกิจการ")
        }),
        certificate26Name: Yup.string().when("checkedEstimate", {
            is: true,
            then: Yup.string().required("กรุณากรอกชื่อศูนย์ประเมินความรู้ความสามารถตามมาตรา 26/4 (2)")
        }),
        estimateLicenseNo: Yup.string().when("checkedEstimate", {
            is: true,
            then: Yup.string().required("กรุณากรอกเลขที่หนังสือรับรองการเป็นศูนย์ประเมินความรู้ความสามารถตามมาตรา 26/4 (2)")
        }),

        fVat20: Yup.mixed().test('fileFormat', 'กรุณาแนบไฟล์ประเภท pdf หรือ jpeg หรือ jpg ', (value) => {
            if (!value) return true
            return value && ['application/pdf', 'image/jpeg', 'image/png'].includes(value.type)
        }).test('fileSize', 'ขนาดไฟล์ต้องไม่เกิน 5MB', (value) => {
            const maxSize = 5000000;
            return !value || (value.size <= maxSize);
        }),

        fIndustryLic: Yup.mixed().test('fileFormat', 'กรุณาแนบไฟล์ประเภท pdf หรือ jpeg หรือ jpg ', (value) => {
            if (!value) return true
            return value && ['application/pdf', 'image/jpeg', 'image/png'].includes(value.type)
        }).test('fileSize', 'ขนาดไฟล์ต้องไม่เกิน 5MB', (value) => {
            const maxSize = 5000000;
            return !value || (value.size <= maxSize);
        }),

        // fAuthorize: Yup.mixed().test('fileFormat', 'กรุณาแนบไฟล์ประเภท pdf หรือ jpeg หรือ jpg ', (value) => {
        //     if (!value) return true
        //     return value && ['application/pdf', 'image/jpeg', 'image/png'].includes(value.type)
        // }).test('fileSize', 'ขนาดไฟล์ต้องไม่เกิน 5MB', (value) => {
        //     const maxSize = 5000000;
        //     return !value || (value.size <= maxSize);
        // }),

        fOther: Yup.mixed().test('fileFormat', 'กรุณาแนบไฟล์ประเภท pdf หรือ jpeg หรือ jpg ', (value) => {
            if (!value) return true
            return value && ['application/pdf', 'image/jpeg', 'image/png'].includes(value.type)
        }).test('fileSize', 'ขนาดไฟล์ต้องไม่เกิน 5MB', (value) => {
            const maxSize = 5000000;
            return !value || (value.size <= maxSize);
        }),

        password: Yup.string()
            .matches(passwordRegex, 'รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร ประกอบด้วย ตัวเลข ตัวอักษรตัวใหญ่ และตัวอักษรตัวเล็ก')
            .required("โปรดระบุรหัสผ่าน"),
        cpassword: Yup.string()
            .oneOf([Yup.ref('password'), null], 'รหัสผ่านไม่ตรงกัน')
            .required('กรุณายืนยันรหัสผ่าน'),
        term: Yup.string().oneOf(["Y"], "กรุณายอมรับเงื่ิอนไข").required("กรุณายอมรับเงื่อนไข"),
        authorizedList: Yup.array().when(
            ["checkedEntrepreneur", "checkedSkillTesting", "checkedEstimate"],
            {
                is: (entre, test, estimate) => entre || test || estimate,
                then: Yup.array()
                    .min(1, "กรุณาเพิ่มข้อมูลผู้มีอำนาจอย่างน้อย 1 คน")
                    .of(
                        Yup.object().shape({
                            authTitleId: Yup.string().required(),
                            authFullName: Yup.string().required(),
                            authPersonalId: Yup.string().required()
                        })
                    ),
                otherwise: Yup.array(),
            }
        ),
    })

    const prefix = "ศูนย์ประเมินความรู้ความสามารถ ";

    if (loading) { return <Loading /> }
    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validateSchema}
            onSubmit={onSubmit}
            enableReinitialize

        >
            {(formik) => {
                // console.log("error", formik.errors)
                // console.log("value", formik.values)

                const handleSubmit = (e) => {
                    e.preventDefault();
                    if (Object.keys(formik.errors).length > 0) {
                        // form has errors
                        let errorText = "";
                        for (const error in formik.errors) {
                            errorText += `<h6>${formik.errors[error]}</h6>`;
                        }
                        Swal.fire({
                            icon: 'error',
                            title: 'ลงทะเบียนไม่สำเร็จ',
                            html: errorText,
                            confirmButtonColor: "#0A66C2",
                            confirmButtonText: "ตกลง",
                        });
                        // set invalid state of form inputs
                        for (const field in formik.errors) {
                            formik.setFieldTouched(field, true);
                        }
                    } else {
                        formik.handleSubmit(e);
                    }
                }
                async function GetAmphurForTesting(provinceCode) {
                    // let { value } = e.target;
                    // console.log(e.target.value);
                    let postData = new FormData();
                    postData.append("provinceCode", provinceCode);

                    try {
                        const responseAmphur = await fetch("/api/MasterData/getAmphur", {
                            method: "POST",
                            body: postData
                        });
                        const amphurData = await responseAmphur.json()
                        setLocationAmphur(amphurData.dataenum);
                        // console.log(amphurData.dataenum);

                    } catch (err) {
                        // console.log("err =>" + err);
                    }
                }
                // ดึง master data ตำบล
                async function GetTumbonForTesting(provinceCode, amphurCode) {
                    let postData = new FormData();
                    postData.append("provinceCode", provinceCode);
                    postData.append("amphurCode", amphurCode);
                    try {
                        let responseTumbon = await fetch("/api/MasterData/getTumbon", {
                            method: "POST",
                            body: postData
                        });
                        const tumbonData = await responseTumbon.json()
                        // setLocationTumbon(tumbonData.dataenum);
                        setLocationTumbon(tumbonData.dataenum);

                    } catch (err) {
                        // console.log("err =>" + err);
                    }
                };
                // หา location_id โดยส่ง จังหวัด อำเภอ ตำบล ไปหา เพื่อที่จะเอามาเก็บใน data base เป็น location_id
                async function GetLocationsIdForTesting(provinceCode, amphurCode, tumbonCode) {

                    let tumbonId = tumbonCode;
                    let provinceId = provinceCode;
                    let amphurId = amphurCode;

                    let postData = new FormData();
                    postData.append("provinceCode", provinceId);
                    postData.append("amphurCode", amphurId);
                    postData.append("tumbonCode", tumbonId);
                    try {
                        let res = await fetch("/api/MasterData/getLocationId", {
                            method: "POST",
                            body: postData
                        });
                        const locationId = await res.json()

                        let setLocationId = locationId.dataenum.map(({ locationId }) => locationId).join().toString();
                        formik.setFieldValue('locationId', setLocationId)

                    } catch (err) {
                        // console.log("err =>" + err);
                    }
                }

                async function GetAmphur(e) {
                    if (e) {
                        let { value } = e.target;
                        // console.log(e.target.value);
                        let postData = new FormData();
                        postData.append("provinceCode", value);

                        try {
                            const responseAmphur = await fetch("/api/MasterData/getAmphur", {
                                method: "POST",
                                body: postData
                            });
                            const amphurData = await responseAmphur.json()
                            setLocationAmphur(amphurData.dataenum);
                            // console.log(amphurData.dataenum);

                        } catch (err) {
                            // console.log("err =>" + err);
                        }
                    } else {
                        return;
                    }
                }
                // ดึง master data ตำบล
                async function GetTumbon(e) {
                    if (e) {
                        let postData = new FormData();
                        postData.append("provinceCode", formik.values.addProvince);
                        postData.append("amphurCode", e.target.value);
                        try {
                            let responseTumbon = await fetch("/api/MasterData/getTumbon", {
                                method: "POST",
                                body: postData
                            });
                            const tumbonData = await responseTumbon.json()
                            // setLocationTumbon(tumbonData.dataenum);
                            setLocationTumbon(tumbonData.dataenum);

                        } catch (err) {
                            // console.log("err =>" + err);
                        }

                    } else {
                        return;
                    }
                };
                // หา location_id โดยส่ง จังหวัด อำเภอ ตำบล ไปหา เพื่อที่จะเอามาเก็บใน data base เป็น location_id
                async function GetLocationsId(e) {

                    let tumbonId = e.target.value;
                    let provinceId = formik.values.addProvince;
                    let amphurId = formik.values.addDistrict;

                    let postData = new FormData();
                    postData.append("provinceCode", provinceId);
                    postData.append("amphurCode", amphurId);
                    postData.append("tumbonCode", tumbonId);
                    try {
                        let res = await fetch("/api/MasterData/getLocationId", {
                            method: "POST",
                            body: postData
                        });
                        const locationId = await res.json()

                        let setLocationId = locationId.dataenum.map(({ locationId }) => locationId).join().toString();
                        formik.setFieldValue('locationId', setLocationId)

                    } catch (err) {
                        // console.log("err =>" + err);
                    }
                }
                // ดึง master data ประเภทกิจกรรม 5 หลัก 
                async function GetIndustry(e) {
                    if (e) {
                        let postData = new FormData();
                        postData.append("industrialCode", e.target.value);
                        try {
                            let res = await fetch("/api/MasterData/getIndustry", {
                                method: "POST",
                                body: postData
                            });
                            const industryData = await res.json()
                            setIndustryData(industryData.dataenum);

                        } catch (e) {
                            // console.log("err =>" + e);
                        }
                    } else {
                        return;
                    }
                };
                //รับค่าที่เป็น true มา แล้วเอามากรองว่า เป็นประเภทไหน ถ้าเป็น 1 ใน 3 นี้ จะโชว์ component ให้ input ชื่อผู้ดำเนินการฝึกแค่อันเดียว
                const ShowName = (names) => {
                    let result = names.filter((name) => {
                        // console.log(name.name)
                        if (name.name === "ผู้ดำเนินการฝึก") {
                            return true
                        } else {
                            return false
                        }
                    })
                    result.length ? setShowName(true) : setShowName(false)
                    // console.log(result)
                }

                // ฟังก์ชั่นเพื่อที่จะเปลี่ยน label หน่วยงานกรมพัฒฯ เป็นไปตามประเภทที่ user เลือก
                const SelectDept = (depts) => {
                    const filtered = depts.filter(dept => dept.check === true) // เลือกค่า state ที่มีค่าเป็น true แล้วให้โชว์แค่ตัวเดียว ก็คือ index 0
                    filtered.length >= 1 ? setInitialDept(filtered[0].dept) : setInitialDept("หน่วยงานกรมพัฒนาฝีมือแรงงานที่ต้องการติดต่อ")

                    ShowName(filtered); //เรียกใช้ function ShowName โดยส่งค่าที่เป็น true ไป 

                    let regisTypeResult = filtered.map(({ id }) => id);
                    setRegisType(regisTypeResult);
                };
                // จัดการการคลิกเลือกประเภทการสมัคร แล้วส่งค่าที่เลือก ไปยัง SelectDept Function
                const HandleChecked = (e) => {
                    const { target } = e;
                    const { value, checked } = target;
                    // show component แต่ละประเภท
                    if (value === "1") {
                        if (checked) {
                            setCheckedentrepreneur(true)
                        } else {
                            setCheckedentrepreneur(false)
                            formik.setFieldValue("entrepreneurName", "")
                            formik.setFieldValue("ssoNumber", "")
                            formik.setFieldValue("subIndustry", "")
                            formik.setFieldValue("activityType", "")
                            formik.setFieldValue("typeBusiness", "")
                            formik.setFieldValue("fMap", "")
                        }
                    } else if (value === "2") {
                        if (checked) {
                            setCheckedTrainer(true)
                        } else {
                            setCheckedTrainer(false)
                            formik.setFieldValue("trainerName", "")
                        }
                    } else if (value === "3") {
                        if (checked) {
                            setCheckedSkillTesting(true)
                        } else {
                            setCheckedSkillTesting(false)
                            formik.setFieldValue("trainerName", "")
                            formik.setFieldValue("testLicenseNo", "")
                        }
                    } else if (value === "4") {
                        if (checked) {
                            setCheckedGroupOfEntrepreneur(true)

                        } else {
                            setCheckedGroupOfEntrepreneur(false)
                            formik.setFieldValue("groupOfEntrepreneurName", "")
                        }
                    } else if (value === "5") {
                        if (checked) {
                            setCheckedEstimate(true)

                        } else {
                            setCheckedEstimate(false)
                            formik.setFieldValue("trainerName", "")
                            formik.setFieldValue("estimateLicenseNo", "")
                        }
                    };

                    // ส่ง value ไปที่ state ใหม่อีกรอบ แล้วส่งไปใช้ใน SelectDept Function
                    const index = checkedDept.findIndex((dept) => dept.id === value);
                    checkedDept[index].check = checked;
                    setCheckedDept([...checkedDept]);
                    SelectDept(checkedDept); //เรียกใช้ SelectDept เพื่อส่งค่าที่เลือกไปที่ function selectdept
                };

                async function CheckCertificateNo() {
                    try {
                        const res = await fetch("/api/Registeration/getCertificateNo", {
                            method: "POST",
                            headers: { "Content-type": "application/json" },
                            body: JSON.stringify({
                                "certificateNo": searchCertificateNo
                            }),
                        });

                        let resJson = await res.json();
                        if (resJson.dataenum !== null) {
                            let centerName = resJson.dataenum.centerName || "";

                            // ตรวจสอบว่ามีคำว่า 'ศูนย์ทดสอบมาตรฐานฝีมือแรงงาน' หรือยัง
                            if (!centerName.includes("ศูนย์ทดสอบมาตรฐานฝีมือแรงงาน")) {
                                centerName = `ศูนย์ทดสอบมาตรฐานฝีมือแรงงาน ${centerName}`;
                            }

                            // setDataCertificate(resJson.dataenum)
                            formik.setFieldValue("testLicenseNo", resJson.dataenum.centerId)
                            formik.setFieldValue("licenseTestName", centerName)
                            formik.setFieldValue("addProvince", resJson.dataenum.addProvince)
                            GetAmphurForTesting(resJson.dataenum.addProvince);
                            GetTumbonForTesting(resJson.dataenum.addProvince, resJson.dataenum.addDistrict);
                            GetAmphurForTesting(resJson.dataenum.addProvince, resJson.dataenum.addDistrict, resJson.dataenum.addTumbon);

                            formik.setFieldValue("addDistrict", resJson.dataenum.addDistrict)
                            formik.setFieldValue("addTumbon", resJson.dataenum.addTumbon)
                            formik.setFieldValue("addNo", resJson.dataenum.addressNo)
                            formik.setFieldValue("addMoo", resJson.dataenum.moo)
                            formik.setFieldValue("addSoi", resJson.dataenum.soi)
                            formik.setFieldValue("addStreet", resJson.dataenum.road)
                            formik.setFieldValue("postcode", resJson.dataenum.postCode)
                            formik.setFieldValue("tel", resJson.dataenum.telMobile)
                            formik.setFieldValue("fax", resJson.dataenum.faxNo)
                            formik.setFieldValue("email", resJson.dataenum.email)

                            setDataCertificate(resJson.dataenum)
                        } else {
                            Swal.fire({
                                icon: "info",
                                title: "ไม่พบข้อมูล",
                                text: "โปรดตรวจสอบข้อมูลอีกครั้ง",
                                confirmButtonColor: "#0A66C2",
                                confirmButtonText: "ตกลง",
                            }).then(() => {
                                formik.setFieldValue("testLicenseNo", "")
                                formik.setFieldTouched("testLicenseNo", true)
                                setSearchCertificateNo("")
                                setDataCertificate(null)
                            })
                        }

                    } catch (err) {
                        // console.log(err)
                    }
                }


                const getTitleName = (titleCode) => {
                    const isTitleName = titleName?.find(title => title.titleCode == titleCode);
                    if (isTitleName) {
                        return isTitleName?.titleThai;
                    }
                    return " ";
                }

                return (

                    <Container className="d-flex justify-content-center mb-5">
                        <div className="form-border">

                            <Form
                                className="p-5 mb-4"
                                onSubmit={handleSubmit}
                                autoComplete="off"
                            >
                                {/* ประเภทผู้สมัคร */}
                                <h4 className="text-center type-register" >
                                    ประเภทผู้สมัคร :
                                    <span className="customer-type fs-4 mx-1">
                                        {registerType}
                                    </span>
                                </h4>

                                {/* input checkbox สำหรับเลือกประเภทการสมัคร */}
                                <FormGroup className="mt-5 d-flex justify-content-start">
                                    <Label
                                        for="customerTypeAr"
                                        name="customerTypeAr">
                                        ประเภทการสมัคร
                                        <span
                                            className="require-input">
                                            *
                                        </span>
                                        {formik.touched.customerTypeAr && formik.errors.customerTypeAr ?
                                            <span
                                                className="text-left text-danger ms-2">
                                                {formik.errors.customerTypeAr}
                                            </span> : null
                                        }
                                    </Label>
                                </FormGroup>
                                <div className="ms-5">
                                    <FormGroup>
                                        <Input
                                            type="checkbox"
                                            className={`mx-2 cus-type ${formik.errors.customerTypeAr ? "input-error" : ""}`}
                                            value="1"
                                            name="entrepreneur"
                                            onClick={HandleChecked} />
                                        <Label>ผู้ประกอบกิจการ</Label>
                                    </FormGroup>

                                    <FormGroup>
                                        <Input
                                            type="checkbox"
                                            className={`mx-2 cus-type ${formik.errors.customerTypeAr ? "input-error" : ""}`}
                                            name="trainer"
                                            value="2"
                                            onClick={HandleChecked} />
                                        <Label>ผู้ดำเนินการฝึก</Label>
                                    </FormGroup>

                                    <FormGroup>
                                        <Input
                                            type="checkbox"
                                            className={`mx-2 cus-type ${formik.errors.customerTypeAr ? "input-error" : ""}`}
                                            name="skillTesting"
                                            value="3"
                                            onClick={HandleChecked} />
                                        <Label>ผู้ดำเนินการทดสอบมาตรฐานฝีมือแรงงาน</Label>
                                    </FormGroup>

                                    {/* <FormGroup>
                                        <Input
                                            type="checkbox"
                                            className={`mx-2 cus-type ${formik.errors.customerTypeAr ? "input-error" : ""}`}
                                            name="groupOfEntrepreneur"
                                            value="4"
                                            onClick={HandleChecked} />
                                        <Label>กลุ่มผู้ประกอบกิจการ</Label>
                                    </FormGroup> */}

                                    <FormGroup>
                                        <Input
                                            type="checkbox"
                                            className={`mx-2 cus-type ${formik.errors.customerTypeAr ? "input-error" : ""}`}
                                            name="estimate"
                                            value="5"
                                            onClick={HandleChecked} />
                                        <Label>ศูนย์ประเมินความรู้ความสามารถตามมาตรา 26/4 (2)</Label>
                                    </FormGroup>
                                </div>


                                {/* input สำหรับเลือกหน่วยงานกรมพัฒฯ */}
                                <FormGroup className="mt-3">
                                    <Label
                                        for="dept">
                                        {initialDept}
                                        <span className="require-input">*</span>
                                        {formik.touched.dept && formik.errors.dept ?
                                            <span
                                                className="text-left text-danger px-3">
                                                {formik.errors.dept}
                                            </span> : null
                                        }
                                    </Label>
                                    <Col>

                                        <Field
                                            name="dept"
                                            component={FormikSelect}
                                            options={deptsData}
                                            placeholder={<div className="input-color text-center">กรุณาเลือกหน่วยงาน</div>}
                                        />

                                    </Col>
                                </FormGroup>

                                {/* input สำหรับใส่เลขทะเบียนนิติบุคคล/เลขทะเบียนพาณิชย์ 13 หลัก */}
                                <Row>
                                    <Label
                                        for="customer_no">เลขทะเบียนนิติบุคคล/เลขทะเบียนพาณิชย์ (13หลัก)
                                        {checkedEstimate === false ? (
                                            <span
                                                className="require-input">
                                                *
                                            </span>
                                        ) : null}


                                        {formik.touched.registerNumber && formik.errors.registerNumber ?
                                            <span className="text-left text-danger px-3">
                                                {formik.errors.registerNumber}
                                            </span> : null
                                        }
                                    </Label>
                                    <br />
                                    <Col>
                                        <Field name="registerNumber">
                                            {({ field, meta, form: { setFieldValue, values } }) => (
                                                <NumericFormat
                                                    allowLeadingZeros
                                                    maxLength={13}
                                                    displayType="number"
                                                    value={values.registerNumber}
                                                    onValueChange={(values, sourceInfo) => {
                                                        setFieldValue(field.name, values.value)
                                                    }}
                                                    customInput={CustomInputNumeric}
                                                    className={formik.errors.registerNumber && formik.touched.registerNumber ? "input-error" : ""}
                                                />
                                            )}
                                        </Field>
                                    </Col>
                                </Row>

                                {/* input สำหรับใส่ ข้อมูลเมื่อคลิกเป็นผู้ประกอบกิจการ */}
                                {checkedEntrepreneur ? (
                                    <>
                                        <FormGroup className="pt-3">
                                            <Label
                                                for="customer_name">ชื่อ (โปรดระบุชื่อ ผู้ประกอบกิจการ)
                                                <span className="require-input">
                                                    *
                                                </span>

                                                {formik.touched.entrepreneurName && formik.errors.entrepreneurName ?
                                                    <span
                                                        className="text-left text-danger px-3">
                                                        {formik.errors.entrepreneurName}
                                                    </span> : null
                                                }
                                            </Label>
                                            <br />
                                            <Col>
                                                <Input
                                                    className={formik.touched.entrepreneurName && formik.errors.entrepreneurName ?
                                                        "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                    }
                                                    type="text"
                                                    name="entrepreneurName"
                                                    {...formik.getFieldProps("entrepreneurName")}
                                                // onBlur={formik.handleBlur}
                                                // onChange={formik.handleChange}
                                                // value={formik.values.entrepreneurName}
                                                />
                                            </Col>
                                        </FormGroup>

                                        <FormGroup className="pt-3">
                                            <Label
                                                for="ssoNumber">เลขที่บัญชีผู้ประกอบกิจการ (10หลัก)
                                                <span className="require-input">*</span>
                                                {formik.touched.ssoNumber && formik.errors.ssoNumber ?
                                                    <span
                                                        className="text-left text-danger px-3">
                                                        {formik.errors.ssoNumber}
                                                    </span>
                                                    : null
                                                }
                                            </Label>
                                            {/* <br /> */}
                                            <Col>
                                                <Field name="ssoNumber">
                                                    {({ field, meta, form: { setFieldValue, values } }) => (
                                                        <NumericFormat
                                                            allowLeadingZeros
                                                            maxLength={10}
                                                            displayType="number"
                                                            value={values.ssoNumber}
                                                            onValueChange={(values, sourceInfo) => {
                                                                setFieldValue(field.name, values.value)
                                                            }}
                                                            customInput={CustomInputNumeric}
                                                            className={formik.errors.ssoNumber && formik.touched.ssoNumber ? "input-error" : ""}
                                                        />
                                                    )}
                                                </Field>


                                                {/* <Input
                                                    className=
                                                    {formik.touched.ssoNumber && formik.errors.ssoNumber ?
                                                        "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                    }
                                                    type="text"
                                                    name="ssoNumber"
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.ssoNumber}
                                                /> */}
                                            </Col>
                                        </FormGroup>
                                    </>
                                ) : null}

                                {/* input สำหรับกรณีเลือก ผู้ดำเนินการฝึก " จะให้กรอกชื่อผู้ดำเนินการฝึกแค่ครั้งเดียว */}
                                {showName ? (
                                    <>
                                        <FormGroup className="pt-3">
                                            <Label
                                                for="customer_name">ชื่อ (โปรดระบุชื่อ ผู้ดำเนินการฝึก)
                                                <span className="require-input">
                                                    *
                                                </span>

                                                {formik.touched.trainerName && formik.errors.trainerName ?
                                                    <span className="text-left text-danger px-3">
                                                        {formik.errors.trainerName}
                                                    </span> : null
                                                }
                                            </Label>
                                            <br />
                                            <Col>
                                                <Input
                                                    className=
                                                    {formik.touched.trainerName && formik.errors.trainerName ?
                                                        "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                    }
                                                    type="text"
                                                    name="trainerName"
                                                    {...formik.getFieldProps("trainerName")}
                                                // onBlur={formik.handleBlur}
                                                // onChange={formik.handleChange}
                                                // value={formik.values.trainerName}
                                                />
                                            </Col>
                                        </FormGroup>
                                    </>
                                ) : null}

                                {/* input เมื่อเลือกเป็น ศูนย์ประเมินความรู้ความสามารถ */}
                                {checkedEstimate && (
                                    <>
                                        <FormGroup className="pt-3">
                                            <Label
                                                for="certificate26Name">ชื่อ (โปรดระบุชื่อ ศูนย์ประเมินความรู้ความสามารถตามมาตรา 26/4 (2))
                                                <span className="require-input">
                                                    *
                                                </span>

                                                {formik.touched.certificate26Name && formik.errors.certificate26Name ?
                                                    <span className="text-left text-danger px-3">
                                                        {formik.errors.certificate26Name}
                                                    </span> : null
                                                }
                                            </Label>
                                            <br />
                                            <Col>
                                                <Input
                                                    className={formik.touched.certificate26Name && formik.errors.certificate26Name ?
                                                        "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                    }
                                                    type="text"
                                                    name="certificate26Name"
                                                    {...formik.getFieldProps("certificate26Name")}
                                                    onChange={(e) => {
                                                        const input = e.target.value;
                                                        // ถ้าเริ่มด้วย prefix แล้ว ให้ใช้ตามนั้น
                                                        if (input.startsWith(prefix)) {
                                                            formik.setFieldValue("certificate26Name", input);
                                                        } else {
                                                            // ถ้าผู้ใช้พยายามลบ prefix หรือกรอกใหม่ ให้เติม prefix กลับเข้าไป
                                                            const suffix = input.replace(prefix, "");
                                                            formik.setFieldValue("certificate26Name", prefix + suffix);
                                                        }
                                                    }}
                                                />
                                            </Col>
                                        </FormGroup>
                                        <FormGroup
                                            row
                                            className="pt-3" >
                                            <Label
                                                for="estimateLicenseNo">
                                                เลขที่หนังสือรับรองการเป็นศูนย์ประเมินความรู้ความสามารถตามมาตรา 26/4 (2)
                                                <span
                                                    className="require-input">
                                                    *
                                                </span>
                                                {formik.touched.estimateLicenseNo && formik.errors.estimateLicenseNo ?
                                                    <span className="text-left text-danger px-1">
                                                        {formik.errors.estimateLicenseNo}
                                                    </span> : null
                                                }
                                            </Label>
                                            <br />
                                            <Col>
                                                <Input
                                                    className=
                                                    {formik.touched.estimateLicenseNo && formik.errors.estimateLicenseNo ?
                                                        "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                    }
                                                    type="text"
                                                    name="estimateLicenseNo"
                                                    onBlur={formik.handleBlur}
                                                    onChange={formik.handleChange}
                                                    value={formik.values.estimateLicenseNo}
                                                />
                                            </Col>
                                        </FormGroup>
                                    </>
                                )}

                                {/* input เมื่อเลือกเป็น กลุ่มผู้ประกอบกิจการ */}
                                {checkedGroupOfEntrepreneur && (
                                    <>
                                        <FormGroup className="pt-3">
                                            <Label
                                                for="customer_name">ชื่อ (โปรดระบุชื่อ กลุ่มผู้ประกอบกิจการ)
                                                <span className="require-input">
                                                    *
                                                </span>
                                                {formik.touched.groupOfEntrepreneurName && formik.errors.groupOfEntrepreneurName ?
                                                    <span
                                                        className="text-left text-danger px-3">
                                                        {formik.errors.groupOfEntrepreneurName}
                                                    </span> : null
                                                }
                                            </Label>
                                            <br />
                                            <Col>
                                                <Input
                                                    className=
                                                    {formik.touched.groupOfEntrepreneurName && formik.errors.groupOfEntrepreneurName ?
                                                        "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                    }
                                                    type="text"
                                                    name="groupOfEntrepreneurName"
                                                    {...formik.getFieldProps("groupOfEntrepreneurName")}
                                                />
                                            </Col>
                                        </FormGroup>

                                    </>
                                )}

                                {/* input เมื่อเลือกเป็น ผู้ดำเนินการทดสอบมาตรฐานฝีมือแรงงาน */}
                                {checkedSkillTesting && (
                                    <div>
                                        <div>
                                            <FormGroup
                                                row
                                                className="pt-3" >
                                                <Label
                                                    for="test_license_no">
                                                    ชื่อ (โปรดระบุชื่อ ผู้ดำเนินการทดสอบ)
                                                    <span
                                                        className="require-input">
                                                        *
                                                    </span>
                                                    {formik.touched.licenseTestName && formik.errors.licenseTestName ?
                                                        <span className="text-left text-danger px-1">
                                                            {formik.errors.licenseTestName}
                                                        </span> : null
                                                    }
                                                </Label>
                                                <br />
                                                <Col>
                                                    <Input
                                                        className=
                                                        {formik.touched.licenseTestName && formik.errors.licenseTestName ?
                                                            "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                        }
                                                        type="text"
                                                        name="licenseTestName"
                                                        disabled
                                                        {...formik.getFieldProps("licenseTestName")}
                                                    />
                                                </Col>
                                            </FormGroup>
                                            <FormGroup
                                                row
                                                className="pt-2" >
                                                <Label
                                                    for="test_license_no">
                                                    เลขที่ใบอนุญาตการเป็นผู้ดำเนินการทดสอบมาตรฐานฝีมือแรงงาน
                                                    <span
                                                        className="require-input">
                                                        *
                                                    </span>
                                                    {formik.touched.testLicenseNo && formik.errors.testLicenseNo ?
                                                        <span className="text-left text-danger px-1">
                                                            {formik.errors.testLicenseNo}
                                                        </span> : null
                                                    }
                                                </Label>
                                                <div className="d-flex">
                                                    <Input
                                                        type="text"
                                                        name="testLicenseNo"
                                                        {...formik.getFieldProps("testLicenseNo")}
                                                        // value={certificate24}
                                                        className={
                                                            formik.touched.testLicenseNo && formik.errors.testLicenseNo ?
                                                                "input-error rounded-pill rounded-end text-center input-color" :
                                                                "rounded-pill rounded-end text-center input-color"
                                                        }
                                                        onChange={(e) => {
                                                            formik.handleChange(e)
                                                            setSearchCertificateNo(e.target.value)
                                                        }}
                                                    // placeholder="ตัวอย่างการใส่เลขที่ใบอนุญาต เช่น สข-0000/2564"
                                                    />
                                                    <button
                                                        type="button"
                                                        // disabled={startDate < new Date() && new Date() < endDate ? true:false}
                                                        className="btn border border-1 rounded-pill rounded-start text-center input-color"
                                                        onClick={() => {
                                                            CheckCertificateNo() // ขอ data
                                                        }}>
                                                        ค้นหา
                                                    </button>
                                                </div>

                                            </FormGroup>
                                        </div>
                                    </div>
                                )}
                                {dataCertificate !== null ?
                                    <>
                                        <div className="cus-type mx-2">
                                            <div className="my-3 px-3">
                                                <h4 className="text-center input-color">ข้อมูลศูนย์ทดสอบมาตรฐานฝีมือแรงงาน</h4>
                                                <Label className="">ชื่อศูนย์ทดสอบมาตรฐานฝีมือแรงงาน : <span className="input-color">{dataCertificate.centerName}</span></Label>
                                                <Label className="mt-2">ชื่อหน่วยงานกรมพัฒนาฝีมือแรงงานในพื้นที่ที่ศูนย์ฝึกอบรมฝีมือแรงงาน: </Label>
                                                <Input
                                                    disabled={true}
                                                    className="rounded-pill text-center input-color"
                                                    value={dataCertificate.site}
                                                />
                                                <Label className="mt-2 w-100 mt-2">วันที่เริ่มดำเนินงาน : <span className="input-color">{dataCertificate.dateCreate}</span></Label>
                                                <Label className="mt-2 w-100 mt-2">สถานะการดำเนินงาน : <span className="input-color">{dataCertificate.workOn === "1" ? "ยังดำเนินการอยู่" : ""}</span></Label>

                                                <div className="mt-2">
                                                    <Label>ที่อยู่ศูนย์ทดสอบมาตรฐานฝีมือแรงงาน:
                                                        <span className="input-color mx-1">{dataCertificate?.address ?? "-"}</span>
                                                        เบอร์โทร : <span className="input-color mx-1">{dataCertificate?.telNo ?? "-"}</span>
                                                        อีเมล : <span className="input-color mx-1">{dataCertificate?.email ?? "-"}</span>
                                                        {/* จังหวัด <span className="input-color mx-1">{dataCertificate.provinceName}</span>
                                                        อำเภอ/เขต <span className="input-color mx-1">{dataCertificate.amphurName}</span>
                                                        ตำบล/แขวง <span className="input-color mx-1">{dataCertificate.tumbonName}</span> */}
                                                    </Label>
                                                </div>
                                            </div>
                                        </div>


                                    </> : null}

                                {/* input สำหรับใส่ที่อยู่ */}
                                <div className="pt-3" >
                                    <Label
                                        for="address">
                                        {formik.values.customerTypeAr.length === 1 && formik.values.customerTypeAr.find(item => item == 3) ? "ที่ตั้ง ศูนย์ทดสอบมาตรฐานฝีมือแรงงาน" : "ที่อยู่"}
                                        <span
                                            className="require-input">
                                            *
                                        </span>

                                        {formik.touched.addNo && formik.errors.addNo ?
                                            <span
                                                className="text-left text-danger px-1">
                                                {formik.errors.addNo}
                                            </span>
                                            : null
                                        }
                                        {formik.touched.addTumbon && formik.errors.addTumbon ?
                                            <span
                                                className="text-left text-danger px-1">
                                                {formik.errors.addTumbon}
                                            </span>
                                            : null
                                        }

                                        {formik.touched.addDistrict && formik.errors.addDistrict ?
                                            <span
                                                className="text-left text-danger px-1">
                                                {formik.errors.addDistrict}
                                            </span>
                                            : null
                                        }

                                        {formik.touched.addProvince && formik.errors.addProvince ?
                                            <span
                                                className="text-left text-danger px-1">
                                                {formik.errors.addProvince}
                                            </span>
                                            : null
                                        }
                                        {formik.touched.postcode && formik.errors.postcode ?
                                            <span
                                                className="text-left text-danger px-1">
                                                {formik.errors.postcode}
                                            </span>
                                            : null
                                        }
                                    </Label>
                                    <div className="px-4 pt-4">
                                        <FormGroup row>
                                            <Label
                                                for="addNo"
                                                sm={2}
                                            >
                                                เลขที่
                                                <span
                                                    className="require-input">
                                                    *
                                                </span>
                                            </Label>
                                            <Col sm={4}>
                                                <Input
                                                    id="addNo"
                                                    name="addNo"
                                                    type="text"
                                                    className=
                                                    {formik.touched.addNo && formik.errors.addNo ?
                                                        "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                    }
                                                    {...formik.getFieldProps("addNo")}
                                                // onBlur={formik.handleBlur}
                                                // onChange={formik.handleChange}
                                                // value={formik.values.addNo}
                                                />
                                            </Col>

                                            <Label
                                                for="moo"
                                                sm={2}
                                            >
                                                หมู่ที่
                                            </Label>
                                            <Col sm={4}>
                                                <Input
                                                    id="addMoo"
                                                    name="addMoo"
                                                    type="text"
                                                    className="rounded-pill text-center input-color"
                                                    {...formik.getFieldProps("addMoo")}
                                                // onChange={formik.handleChange}
                                                // value={formik.values.addMoo}
                                                />
                                            </Col>
                                        </FormGroup>

                                        <FormGroup row>
                                            <Label
                                                for="soi"
                                                sm={2}
                                            >
                                                ซอย
                                            </Label>
                                            <Col sm={4}>
                                                <Input
                                                    id="addSoi"
                                                    name="addSoi"
                                                    type="text"
                                                    className="rounded-pill text-center input-color"
                                                    {...formik.getFieldProps("addSoi")}
                                                // onChange={formik.handleChange}
                                                // value={formik.values.addSoi}
                                                />
                                            </Col>

                                            <Label
                                                for="street"
                                                sm={2}
                                            >
                                                ถนน
                                            </Label>
                                            <Col sm={4}>
                                                <Input
                                                    id="addStreet"
                                                    name="addStreet"
                                                    type="text"
                                                    className="rounded-pill text-center input-color"
                                                    // onChange={formik.handleChange}
                                                    // value={formik.values.addStreet}
                                                    {...formik.getFieldProps("addStreet")}
                                                />
                                            </Col>
                                        </FormGroup>

                                        <FormGroup row>
                                            <Label
                                                for="addProvince"
                                                sm={2}
                                            >
                                                จังหวัด
                                                <span
                                                    className="require-input">
                                                    *
                                                </span>
                                            </Label>
                                            <Col sm={4}>
                                                <Input
                                                    id="addProvince"
                                                    name="addProvince"
                                                    type="select"
                                                    className=
                                                    {formik.touched.addProvince && formik.errors.addProvince ?
                                                        "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                    }
                                                    {...formik.getFieldProps("addProvince")}
                                                    // onBlur={formik.handleBlur}
                                                    onChange={(e) => {
                                                        formik.handleChange(e)
                                                        formik.setFieldValue("addDistrict", "กรุณาเลือกอำเภอ/เขต");
                                                        formik.setFieldValue("addTumbon", "กรุณาเลือกตำบล/แขวง");
                                                        GetAmphur(e)
                                                    }}
                                                // value={formik.values.addProvince}
                                                >
                                                    <option defaultValue="กรุณาเลือกจังหวัด">
                                                        กรุณาเลือกจังหวัด
                                                    </option>
                                                    {locationProvince.map(province => (
                                                        <option
                                                            key={province.provinceCode}
                                                            value={province.provinceCode}
                                                        >
                                                            {province.provinceName}
                                                        </option>
                                                    ))}
                                                </Input>
                                            </Col>

                                            <Label
                                                for="district_id"
                                                sm={2}
                                            >
                                                อำเภอ/เขต
                                                <span
                                                    className="require-input">
                                                    *
                                                </span>
                                            </Label>
                                            <Col sm={4}>
                                                <Input
                                                    id="addDistrict"
                                                    name="addDistrict"
                                                    type="select"
                                                    className=
                                                    {formik.touched.addDistrict && formik.errors.addDistrict ?
                                                        "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                    }
                                                    {...formik.getFieldProps("addDistrict")}
                                                    onChange={(e) => {
                                                        formik.handleChange(e)
                                                        formik.setFieldValue("addTumbon", "กรุณาเลือกตำบล/แขวง");
                                                        GetTumbon(e)
                                                    }}

                                                >
                                                    <option defaultValue="กรุณาเลือกอำเภอ/เขต" >
                                                        กรุณาเลือกอำเภอ/เขต
                                                    </option>
                                                    {locationAmphur.map(amphur => (
                                                        <option
                                                            key={amphur.amphurCode}
                                                            value={amphur.amphurCode}>
                                                            {amphur.amphurName}
                                                        </option>
                                                    ))}
                                                </Input>
                                            </Col>
                                        </FormGroup>

                                        <FormGroup row>
                                            <Label
                                                for="addTumbon"
                                                sm={2}
                                            >
                                                ตำบล/แขวง
                                                <span
                                                    className="require-input">
                                                    *
                                                </span>
                                            </Label>
                                            <Col sm={4}>
                                                <Input
                                                    id="addTumbon"
                                                    name="addTumbon"
                                                    type="select"
                                                    className=
                                                    {formik.touched.addTumbon && formik.errors.addTumbon ?
                                                        "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                    }
                                                    {...formik.getFieldProps("addTumbon")}
                                                    onChange={(e) => {
                                                        formik.handleChange(e)
                                                        GetLocationsId(e)
                                                    }}

                                                // value={formik.values.addTumbon}
                                                >
                                                    <option defaultValue="กรุณาเลือกตำบล/แขวง">
                                                        กรุณาเลือกตำบล/แขวง
                                                    </option>
                                                    {locationTumbon.map(tumbon => (
                                                        <option
                                                            key={tumbon.tumbonCode}
                                                            value={tumbon.tumbonCode}
                                                        >
                                                            {tumbon.tumbonName}
                                                        </option>
                                                    ))}
                                                </Input>
                                            </Col>

                                            <Label
                                                for="postcode"
                                                sm={2}
                                            >
                                                รหัสไปรษณีย์
                                                <span
                                                    className="require-input">
                                                    *
                                                </span>
                                            </Label>
                                            <Col sm={4}>
                                                <Input
                                                    maxLength={5}
                                                    id="postcode"
                                                    name="postcode"
                                                    type="text"
                                                    className=
                                                    {formik.touched.postcode && formik.errors.postcode ?
                                                        "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                    }
                                                    {...formik.getFieldProps("postcode")}
                                                />
                                            </Col>
                                        </FormGroup>
                                    </div>
                                </div>

                                {/* input สำหรับใส่เบอร์โทรศัพท์และโทรสาร */}
                                <Row className="pt-3">
                                    <Col>
                                        <Label
                                            for="tel">โทรศัพท์
                                            <span
                                                className="require-input">
                                                *
                                            </span>
                                            {formik.touched.tel && formik.errors.tel ?
                                                <span className="text-left text-danger px-1">
                                                    {formik.errors.tel}
                                                </span> : null
                                            }
                                        </Label>
                                        <Col>
                                            <Input
                                                className=
                                                {formik.touched.tel && formik.errors.tel ?
                                                    "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                }
                                                type="text"
                                                name="tel"
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.tel}
                                            />
                                        </Col>
                                    </Col>

                                    <Col>
                                        <Label for="fax">
                                            โทรสาร
                                            {formik.touched.fax && formik.errors.fax ?
                                                <span className="text-left text-danger px-1">
                                                    {formik.errors.fax}
                                                </span> : null
                                            }
                                        </Label>
                                        <Col>
                                            <Input
                                                className=
                                                {formik.touched.fax && formik.errors.fax ?
                                                    "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                }
                                                type="text"
                                                name="fax"
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.fax}
                                            />
                                        </Col>
                                    </Col>
                                </Row>

                                {/* input สำหรับใส่ email ชื่อ-นามสกุล เบอร์โทรผู้ประสานงาน */}
                                <FormGroup className="pt-3">
                                    <Label
                                        for="email">
                                        อีเมล
                                        <span
                                            className="require-input">
                                            *
                                        </span>
                                        {formik.touched.email && formik.errors.email ?
                                            <span className="text-left text-danger px-1">
                                                {formik.errors.email}
                                            </span> : null
                                        }
                                    </Label>
                                    <br />
                                    <Col>
                                        <Input
                                            className=
                                            {formik.touched.email && formik.errors.email ?
                                                "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                            }
                                            type="text"
                                            name="email"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.email}
                                            autoComplete="off"
                                        />
                                    </Col>
                                </FormGroup>

                                <Row className="pt-3">
                                    <Col>
                                        <Label
                                            for="contactName">
                                            ชื่อ-นามสกุลผู้ประสานงาน
                                            <span className="require-input">
                                                *
                                            </span>
                                            {formik.touched.contactName && formik.errors.contactName ?
                                                <span className="text-left text-danger px-1">
                                                    {formik.errors.contactName}
                                                </span> : null
                                            }
                                        </Label>
                                        <Col>
                                            <Input
                                                className=
                                                {formik.touched.contactName && formik.errors.contactName ?
                                                    "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                }
                                                type="text"
                                                name="contactName"
                                                onBlur={formik.handleBlur}
                                                onChange={formik.handleChange}
                                                value={formik.values.contactName}

                                            />
                                        </Col>
                                    </Col>

                                    <Col>
                                        <Label
                                            for="contactNo">
                                            หมายเลขโทรศัพท์ผู้ประสานงาน
                                            <span
                                                className="require-input">
                                                *
                                            </span>
                                            {formik.touched.contactNo && formik.errors.contactNo ?
                                                <span className="text-left text-danger px-1">
                                                    {formik.errors.contactNo}
                                                </span>
                                                : null
                                            }
                                        </Label>
                                        <Col>
                                            <Input
                                                className={formik.touched.contactNo && formik.errors.contactNo ?
                                                    "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                }
                                                type="text"
                                                name="contactNo"
                                                onBlur={formik.handleBlur}
                                                onChange={formik.handleChange}
                                                value={formik.values.contactNo}
                                            />
                                        </Col>
                                    </Col>
                                </Row>

                                {checkedEntrepreneur || checkedSkillTesting || checkedEstimate ? (
                                    <div className="mt-4">
                                        <FieldArray name="authorizedList">
                                            {({ push, remove, replace }) => (
                                                <>
                                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                                        <Label
                                                            for="address">ข้อมูลผู้มีอำนาจ
                                                            <span
                                                                className="require-input">
                                                                *
                                                            </span>
                                                        </Label>

                                                        <button
                                                            className="btn-blue create-button-form"
                                                            type="button"
                                                            // disabled={disableButton}
                                                            onClick={() => {
                                                                setEditMode("add");
                                                                setEditData(initialEmptyPerson);
                                                                setModalOpen(true);
                                                            }}
                                                        >
                                                            <BsPlusLg className="mx-2" />
                                                            เพิ่มผู้มีอำนาจ
                                                        </button>
                                                    </div>

                                                    <Table className="styled-table mt-2" stype={{ backgroundColor: "#ffff" }} striped bordered>
                                                        <thead className="text-center">
                                                            <tr>
                                                                <th>ลำดับ</th>
                                                                {/* <th>คำนำหน้า</th> */}
                                                                <th>ชื่อ - สกุล</th>
                                                                <th>เลขบัตรประจำตัวประชาชน/เลข Passport</th>
                                                                <th></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {formik.values.authorizedList.length === 0 ? (
                                                                <tr>
                                                                    <td colSpan="6" className="text-center">
                                                                        ไม่มีข้อมูล
                                                                    </td>
                                                                </tr>
                                                            ) : (
                                                                formik.values.authorizedList.map((item, index) => (
                                                                    <tr key={index}>
                                                                        <td className="text-center">{index + 1}</td>
                                                                        {/* <td>{item.authTitleId}</td> */}
                                                                        <td>{getTitleName(item.authTitleId)} {item.authFullName}</td>
                                                                        <td className="text-center">{item.authPersonalId}</td>
                                                                        {/* <td>{item.authAddressProvince}</td> */}
                                                                        <td className="text-center">
                                                                            <button
                                                                                type="button"
                                                                                className="btn border border-1 mx-1"
                                                                                onClick={() => {
                                                                                    setEditMode("edit");
                                                                                    setEditIndex(index);
                                                                                    setEditData(item);
                                                                                    setModalOpen(true);
                                                                                }}
                                                                            >
                                                                                <FiEdit3 style={{ color: rootColorPrimary }} />
                                                                            </button>
                                                                            <button
                                                                                type="button"
                                                                                className="btn border border-1 mx-1"
                                                                                onClick={() => remove(index)}

                                                                            >
                                                                                <AiOutlineDelete style={{ color: rootColorErrors }} />
                                                                            </button>

                                                                        </td>
                                                                    </tr>
                                                                ))
                                                            )}
                                                        </tbody>
                                                    </Table>

                                                    <AddEditAuthorizedModal
                                                        isOpen={modalOpen}
                                                        toggle={() => setModalOpen(false)}
                                                        mode={editMode}
                                                        initialData={editData}
                                                        onSubmit={(data) => {
                                                            if (editMode === "add") {
                                                                push(data);
                                                            } else {
                                                                replace(editIndex, data);
                                                            }
                                                        }}
                                                        copyAddressData={formik.values}
                                                    />
                                                </>
                                            )}
                                        </FieldArray>

                                    </div>
                                ) : null}


                                {/* input เมื่อเลือกเป็น ผู้ประกอบกิจการ */}
                                {checkedEntrepreneur && (
                                    <div>
                                        <div className="pt-3">
                                            <Label
                                                for="industry_type">
                                                ประเภทอุตสาหกรรม
                                                <span
                                                    className="require-input">
                                                    *
                                                </span>
                                            </Label>
                                            <div className="px-4 pt-4">
                                                <Row>
                                                    <Label
                                                        for="industryType">
                                                        หมวดย่อย (2หลัก)
                                                        {formik.touched.subIndustry && formik.errors.subIndustry ?
                                                            <span className="text-left text-danger px-1">
                                                                {formik.errors.subIndustry}
                                                            </span>
                                                            : null
                                                        }
                                                    </Label>

                                                    <Col>
                                                        <Input
                                                            id="subIndustry"
                                                            name="subIndustry"
                                                            type="select"
                                                            className=
                                                            {formik.touched.subIndustry && formik.errors.subIndustry ?
                                                                "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                            }
                                                            onBlur={formik.handleBlur}
                                                            onChange={(e) => {
                                                                formik.handleChange(e)
                                                                GetIndustry(e)
                                                            }}
                                                            value={formik.values.subIndustry}

                                                        >
                                                            <option defaultValue value={"กรุณาเลือกประเภทอุตสาหกรรม (หมวดย่อย 2 หลัก)"}>
                                                                กรุณาเลือกประเภทอุตสาหกรรม (หมวดย่อย 2 หลัก)
                                                            </option>
                                                            {industrialData.map(industrial => (
                                                                <option
                                                                    key={industrial.industrialCodeNew}
                                                                    value={industrial.industrialCodeNew}
                                                                >
                                                                    {industrial.industrialCodeNew}-{industrial.industrialDescNew}
                                                                </option>
                                                            ))}
                                                        </Input>
                                                    </Col>
                                                </Row>

                                                <Row className="mt-3">
                                                    <Label
                                                        for="activityType">
                                                        กิจกรรม (5หลัก)
                                                        {formik.touched.activityType && formik.errors.activityType ?
                                                            <span className="text-left text-danger px-1">
                                                                {formik.errors.activityType}
                                                            </span> : null
                                                        }
                                                    </Label>
                                                    <Col>
                                                        <Input
                                                            id="activityType"
                                                            name="activityType"
                                                            type="select"
                                                            className=
                                                            {formik.touched.activityType && formik.errors.activityType ?
                                                                "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                            }
                                                            onBlur={formik.handleBlur}
                                                            onChange={formik.handleChange}
                                                            value={formik.values.activityType}

                                                        >
                                                            <option defaultValue value={"กรุณาเลือกประเภทอุตสาหกรรม (กิจกรรม 5 หลัก)"}>
                                                                กรุณาเลือกประเภทอุตสาหกรรม (กิจกรรม 5 หลัก)
                                                            </option>

                                                            {industryData.map(industry => (
                                                                <option
                                                                    key={industry.indusCode}
                                                                    value={industry.indusCode}>
                                                                    {industry.indusCode}-{industry.indusTname}
                                                                </option>
                                                            ))}
                                                        </Input>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </div>


                                        <Row className="pt-3">
                                            <Col>
                                                <Label
                                                    for="type_business">
                                                    ประกอบกิจการประเภท
                                                    <span className="require-input">
                                                        *
                                                    </span>
                                                    {formik.touched.typeBusiness && formik.errors.typeBusiness ?
                                                        <span className="text-left text-danger px-1">
                                                            {formik.errors.typeBusiness}
                                                        </span> : null
                                                    }
                                                </Label>
                                                <Col>
                                                    <Input
                                                        type="text"
                                                        name="typeBusiness"
                                                        id="typeBusiness"
                                                        className=
                                                        {formik.touched.typeBusiness && formik.errors.typeBusiness ?
                                                            "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                        }
                                                        onBlur={formik.handleBlur}
                                                        onChange={formik.handleChange}
                                                        value={formik.values.typeBusiness}
                                                    />
                                                </Col>
                                            </Col>

                                            <Col>
                                                <Label
                                                    for="employAmt">
                                                    มีลูกจ้างตั้งแต่ 100 คนขึ้นไป เมื่อวันที่
                                                </Label>
                                                <Col>
                                                    <Field name="employDate" component={(props) => <DatePickerInput {...props} maxDate={new Date()} />} />
                                                </Col>
                                            </Col>
                                        </Row>

                                        <FormGroup row className="pt-3" >
                                            <Label
                                                for="fVat20">
                                                สำเนาใบทะเบียนภาษีมูลค่าเพิ่ม (ภ.พ.20) หรือ สำเนาใบทะเบียนภาษีธุรกิจเฉพาะ (ภ.ธ. 20)
                                                {formik.touched.fVat20 && formik.errors.fVat20 ?
                                                    <span className="text-left text-danger px-1">
                                                        {formik.errors.fVat20}
                                                    </span> : null
                                                }
                                            </Label>
                                            <br />
                                            <Col>
                                                <Input
                                                    className={formik.touched.fVat20 && formik.errors.fVat20 ?
                                                        "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                    }
                                                    type="file"
                                                    name="fVat20"
                                                    onChange={(e) => {
                                                        formik.handleChange(e)
                                                        formik.setFieldValue("fVat20", e.target.files[0])
                                                    }}
                                                    onBlur={formik.handleBlur}
                                                />
                                            </Col>
                                        </FormGroup>

                                        <FormGroup Row className="pt-3" >
                                            <Label
                                                for="fIndustryLic">สำเนาใบอนุญาตประกอบกิจการโรงงาน (ร.ง.4)
                                                {formik.touched.fIndustryLic && formik.errors.fIndustryLic ?
                                                    <span className="text-left text-danger px-1">
                                                        {formik.errors.fIndustryLic}
                                                    </span> : null
                                                }
                                            </Label>
                                            <br />
                                            <Col>
                                                <Input
                                                    className={formik.touched.fIndustryLic && formik.errors.fIndustryLic ?
                                                        "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                    }
                                                    type="file"
                                                    name="fIndustryLic"
                                                    onChange={(e) => {
                                                        formik.handleChange(e)
                                                        formik.setFieldValue("fIndustryLic", e.target.files[0])
                                                    }}
                                                />
                                            </Col>
                                        </FormGroup>

                                        <FormGroup row className="pt-3" >
                                            <Label
                                                for="fMap">
                                                แผนที่ตั้งสถานประกอบกิจการ
                                                <span
                                                    className="require-input">
                                                    *
                                                </span>
                                                {formik.touched.fMap && formik.errors.fMap ?
                                                    <span className="text-left text-danger px-1">
                                                        {formik.errors.fMap}
                                                    </span> : null
                                                }
                                            </Label>
                                            <br />
                                            <Col>
                                                <Input
                                                    className=
                                                    {formik.touched.fMap && formik.errors.fMap ?
                                                        "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                    }
                                                    type="file"
                                                    name="fMap"
                                                    onChange={(e) => {
                                                        formik.handleChange(e)
                                                        if (e.target && e.target.files[0]) {
                                                            formik.setFieldValue("fMap", e.target.files[0])
                                                        }
                                                    }}
                                                    onBlur={formik.handleBlur}
                                                />
                                            </Col>
                                        </FormGroup>
                                    </div>
                                )}

                                {/* input สำหรับแนบไฟล์ */}
                                <FormGroup row className="pt-3" >
                                    <Label
                                        for="fLicense">
                                        สำเนาหนังสือรับรองการจดทะเบียนนิติบุคคลพร้อมวัตถุประสงค์
                                        <span
                                            className="require-input">
                                            *
                                        </span>
                                        {formik.touched.fLicense && formik.errors.fLicense ? <span className="text-left text-danger px-1">{formik.errors.fLicense}</span> : null}
                                    </Label>
                                    <br />
                                    <Col>
                                        <Input
                                            className={formik.touched.fLicense && formik.errors.fLicense ? "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"}
                                            type="file"
                                            name="fLicense"
                                            onBlur={formik.handleBlur}
                                            onChange={(e) => {
                                                formik.handleChange(e)
                                                if (e.target && e.target.files[0]) {
                                                    formik.setFieldValue("fLicense", e.target.files[0])
                                                }
                                            }}
                                        />
                                        <FormText
                                            className="require-input">
                                            * ใบอนุญาตจัดตั้งศูนย์ทดสอบมาตรฐานฝีมือแรงงาน
                                        </FormText>
                                    </Col>
                                </FormGroup>
                                {/* <FormGroup
                                    row
                                    className="pt-3">
                                    <Label
                                        for="fAuthorize">
                                        หนังสือมอบอำนาจ(เฉพาะกรณีมอบอำนาจ พร้อมติดตั้งอากรแสตมป์ตามที่ประมวลรัษฎากรกำหนด)
                                        {formik.touched.fAuthorize && formik.errors.fAuthorize ? <span className="text-left text-danger px-1">{formik.errors.fAuthorize}</span> : null}
                                    </Label>
                                    <br />
                                    <Col>
                                        <Input
                                            className={formik.touched.fAuthorize && formik.errors.fAuthorize ? "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"}
                                            type="file"
                                            name="fAuthorize"
                                            onChange={(e) => {
                                                formik.handleChange(e)
                                                if (e.target && e.target.files[0]) {
                                                    formik.setFieldValue("fAuthorize", e.target.files[0])
                                                }

                                            }}
                                            onBlur={formik.handleBlur}
                                        />
                                    </Col>
                                </FormGroup> */}

                                {/* input เมื่อเลือกกลุ่มผู้ประกอบกิจการ */}
                                {checkedGroupOfEntrepreneur && (
                                    <>
                                        <div>
                                            <FormGroup
                                                row
                                                className="pt-2" >
                                                <Label
                                                    for="fOther">
                                                    เอกสารอื่นๆ
                                                    {formik.touched.fOther && formik.errors.fOther ? <span className="text-left text-danger px-1">{formik.errors.fOther}</span> : null}
                                                </Label>
                                                <br />
                                                <Col>
                                                    <Input
                                                        className={formik.touched.fOther && formik.errors.fOther ? "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"}
                                                        type="file"
                                                        name="fOther"
                                                        onChange={(e) => {
                                                            formik.handleChange(e)
                                                            if (e.target && e.target.files[0]) {
                                                                formik.setFieldValue("fOther", e.target.files[0])
                                                            }
                                                        }}
                                                        onBlur={formik.handleBlur}
                                                    />
                                                </Col>
                                            </FormGroup>
                                        </div>
                                    </>
                                )}

                                {/* input สำหรับใส่ password and confirm password */}
                                <FormGroup row className="pt-3">
                                    <Label
                                        for="password">
                                        รหัสผ่าน
                                        <span
                                            className="require-input">
                                            *
                                        </span>
                                        {formik.touched.password && formik.errors.password ?
                                            <span
                                                className="text-left text-danger px-1">
                                                {formik.errors.password}
                                            </span>
                                            : null
                                        }
                                    </Label>
                                    <Col className="position-relative">
                                        <Input
                                            id="password"
                                            name="password"
                                            type={isRevealPwd ? "text" : "password"}
                                            className={formik.touched.password && formik.errors.password ? "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"}
                                            onBlur={formik.handleBlur}
                                            onChange={formik.handleChange}
                                            value={formik.values.password}
                                        />
                                        {isRevealPwd ? <BiShow className="icon-item-show-register"
                                            onClick={() => setIsRevealPwd(prevState => !prevState)}
                                        /> : <BiHide className="icon-item-show-register"
                                            onClick={() => setIsRevealPwd(prevState => !prevState)}
                                        />}
                                        <FormText
                                            className="require-input">
                                            *ภาษาอังกฤษ 8 ตัว ประกอบด้วย ตัวพิมพ์ใหญ่ พิมพ์เล็ก และตัวเลข
                                        </FormText>
                                    </Col>
                                </FormGroup>
                                <FormGroup className="pt-3">
                                    <Label
                                        for="cpassword">
                                        ยืนยันรหัสผ่าน
                                        <span
                                            className="require-input">
                                            *
                                        </span>
                                        {formik.touched.cpassword && formik.errors.cpassword ?
                                            <span
                                                className="text-left text-danger px-1">
                                                {formik.errors.cpassword}
                                            </span>
                                            : null
                                        }
                                    </Label>
                                    <Col className="position-relative">
                                        <Input
                                            id="cpassword"
                                            name="cpassword"
                                            type={isRevealPwd2 ? "text" : "password"}
                                            className={formik.touched.cpassword && formik.errors.cpassword ? "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"}
                                            onBlur={formik.handleBlur}
                                            onChange={formik.handleChange}
                                            value={formik.values.cpassword}
                                        />
                                        {isRevealPwd2 ? <BiShow className="icon-item-show-register-2"
                                            onClick={() => setIsRevealPwd2(prevState => !prevState)}
                                        /> : <BiHide className="icon-item-show-register-2"
                                            onClick={() => setIsRevealPwd2(prevState => !prevState)}
                                        />}
                                    </Col>
                                </FormGroup>
                                <FormGroup className="pt-3 d-flex">
                                    <Input
                                        type="checkbox"
                                        name="term"
                                        id="term"
                                        className=
                                        {formik.touched.term && formik.errors.term ?
                                            "input-error text-center input-color me-3" : "text-center input-color me-3 "
                                        }
                                        onBlur={formik.handleBlur}
                                        onChange={(e) => {
                                            if (e.target.checked) {
                                                formik.setFieldValue("term", "Y")
                                            } else {
                                                formik.setFieldValue("term", "N")
                                            }
                                        }}
                                        value={formik.values.term}
                                        checked={formik.values.term === "Y"}
                                    />
                                    <Label for="term" className="w-100">
                                        ข้าพเจ้าได้อ่านและรับทราบ<a href="http://eit2.dsd.go.th/~pdpa/" target="blank">นโยบายการคุ้มครองข้อมูลส่วนบุคคลของกรมพัฒนาฝีมือแรงงาน</a>และยินยอมเปิดเผยข้อมูลส่วนบุคคลเพื่อใช้ประโยชน์ในการเชื่อมโยงและบูรณาการข้อมูลกับหน่วยงานภาครัฐ
                                        <span
                                            className="require-input">
                                            *
                                        </span>
                                        {formik.touched.term && formik.errors.term ?
                                            <span
                                                className="text-left text-danger px-1">
                                                {formik.errors.term}
                                            </span>
                                            : null
                                        }
                                    </Label>
                                    {/* <Col className="position-relative">
                                        <Input
                                            id="cpassword"
                                            name="cpassword"
                                            type={isRevealPwd2 ? "text" : "password"}
                                            className={formik.touched.cpassword && formik.errors.cpassword ? "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"}
                                            onBlur={formik.handleBlur}
                                            onChange={formik.handleChange}
                                            value={formik.values.cpassword}
                                        />
                                        {isRevealPwd2 ? <BiShow className="icon-item-show-register-2"
                                            onClick={() => setIsRevealPwd2(prevState => !prevState)}
                                        /> : <BiHide className="icon-item-show-register-2"
                                            onClick={() => setIsRevealPwd2(prevState => !prevState)}
                                        />}
                                    </Col> */}
                                </FormGroup>


                                <div className="text-center p-5">
                                    <button
                                        className="submit-btn"
                                        type="submit">
                                        บันทึก
                                    </button>
                                </div>
                            </Form>
                        </div>
                    </Container>
                )
            }}

        </Formik>

    );
}
